export function cleanupPhoneNumber (phoneNumber) {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return ''
  }

  phoneNumber = phoneNumber.trim()
  const leadingPlus = phoneNumber.charAt(0) === '+' ? '+' : ''

  return leadingPlus + phoneNumber.replace(/[^0-9]/gi, '')
}

export function validatePhoneNumber (phoneNumber) {
  if (!phoneNumber || phoneNumber.length < 8 || phoneNumber.length > 20) {
    return false
  }

  // check if phoneNumber has anything other than digits and + sign
  if (!/^\+?\d+$/.test(phoneNumber)) {
    // if (phoneNumber.match(/[^0-9+]/gi)) {
    return false
  }

  // check if phone number has more than two zeros at the beginning
  if (/^0{3}/.test(phoneNumber)) {
    return false
  }

  // check if phone number has more than seven consecutive zeros
  if (/0{8}/.test(phoneNumber)) {
    return false
  }

  return true
}
